var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticStyle: { padding: "50px 0 20px", position: "unset" },
      attrs: { id: "screen-search" },
    },
    [
      _c(
        "div",
        { staticClass: "section-inner l-centered" },
        [
          _c(
            "div",
            {
              staticClass: "search-request search-header",
              staticStyle: { position: "relative" },
            },
            [
              _c("div", { staticClass: "search-request-submit" }, [
                _c("div", { staticClass: "search-request-status" }, [
                  _c("i", {
                    class: _vm.searchIconClassObject,
                    on: { click: _vm.searchSubmit },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _vm.request
                ? _c(
                    "div",
                    {
                      staticClass: "search-request-erase",
                      attrs: { id: "search-erase" },
                      on: { click: _vm.clearRequest },
                    },
                    [_c("i", { staticClass: "lnr lnr-cross" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "search-request-holder" }, [
                _c("input", {
                  directives: [
                    { name: "focus", rawName: "v-focus" },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.request,
                      expression: "request",
                    },
                  ],
                  attrs: {
                    type: "text",
                    placeholder: "ИНН, ОГРН, ОКПО, название или ФИО",
                    id: "search-request",
                    autocomplete: "off",
                  },
                  domProps: { value: _vm.request },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.request = $event.target.value
                      },
                      _vm.searchInputHandle,
                    ],
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.searchSubmit.apply(null, arguments)
                    },
                  },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticStyle: {
                cursor: "pointer",
                "text-align": "center",
                display: "block",
              },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.raw,
                    expression: "raw",
                  },
                ],
                staticStyle: { position: "relative", top: "1px" },
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.raw)
                    ? _vm._i(_vm.raw, null) > -1
                    : _vm.raw,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.raw,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.raw = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.raw = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.raw = $$c
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "h4",
                {
                  staticStyle: {
                    margin: "15px 0",
                    display: "inline-block",
                    "text-transform": "none",
                    "font-size": "17px",
                    color: "#757575",
                  },
                },
                [_vm._v("Исключить из результатов поиска учреждённые ЮЛ")]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              { staticStyle: { "text-align": "center", "font-size": "12px" } },
              [
                _c(
                  "span",
                  {
                    staticClass: "dashed",
                    on: {
                      click: function () {
                        return (this$1.helpOpened = !this$1.helpOpened)
                      },
                    },
                  },
                  [
                    _vm._v("Помощь "),
                    _c("i", {
                      staticClass: "fa fa-question-circle",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.helpOpened
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      "margin-top": "10px",
                    },
                  },
                  [_vm._m(0)]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("filters"),
          _vm._v(" "),
          _c("scroll-up"),
          _vm._v(" "),
          _vm.searchMore
            ? _c(
                "div",
                {
                  staticClass: "search-header",
                  staticStyle: { "text-align": "center" },
                  attrs: { id: "search-more" },
                },
                [
                  _c("div", { attrs: { id: "search-show" } }),
                  _vm._v(" "),
                  _vm._m(1),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("search-result"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "search-help",
        staticStyle: {
          margin: "0 auto",
          border: "solid 1px #ccc",
          background: "#eee",
          "border-radius": "6px",
          padding: "15px",
          "max-width": "30em",
          "font-size": "14px",
          "text-align": "left",
        },
      },
      [
        _c(
          "span",
          {
            staticStyle: {
              display: "inline-block",
              "font-size": "16px",
              "margin-bottom": "5px",
            },
          },
          [
            _vm._v(
              "Поиск может осуществляться по следующим параметрам в любых сочетаниях:"
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          { staticStyle: { display: "inline-block", "font-weight": "700" } },
          [_vm._v("Для поиска юридических лиц")]
        ),
        _vm._v(" "),
        _c(
          "span",
          { staticStyle: { display: "inline-block", "margin-bottom": "5px" } },
          [
            _vm._v(
              "ИНН, ОГРН, ОКПО, краткое или полное название ЮЛ, ФИО руководителя ЮЛ (частично или полностью), ФИО совладельца ЮЛ (частично или полностью)."
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          { staticStyle: { display: "inline-block", "font-weight": "700" } },
          [_vm._v("Для поиска физических лиц и ИП")]
        ),
        _vm._v(" "),
        _c(
          "span",
          { staticStyle: { display: "inline-block", "margin-bottom": "5px" } },
          [
            _vm._v(
              "ИНН ФЛ, ОГРНИП, ФИО ИП/руководителя ЮЛ/совладельца ЮЛ (частично или полностью)."
            ),
          ]
        ),
        _vm._v(" "),
        _c("span", { staticStyle: { display: "inline-block" } }, [
          _vm._v(
            'Для поиска точного совпадения необходимо использовать кавычки " ". Например, "НУРАЛИЕВ БОРИС ГЕОРГИЕВИЧ", "ИНВЕСТ СТРОЙ ГРУПП"'
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "div",
        {
          staticStyle: {
            display: "inline-block",
            "font-size": "14px",
            color: "#c00",
            cursor: "pointer",
            "margin-bottom": "30px",
          },
          attrs: { id: "search-erase-all" },
        },
        [
          _c("i", { staticClass: "lnr lnr-cross" }),
          _vm._v(" Сбросить все настройки поиска"),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }